var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 554.67 554.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #ec6608;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 554.67,
    height: 554.66
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.87,337.3l8.19-7.79-42.67-48.19,24.52-12.66,69.19,31.41,84.66-54.67c31.21-15.58,26.79-20.75,17.47-35.02-7.1-10.75-24.06-28.74-37.35-41.15l-101.22-77.28,30.71-15.78c12.28-6.28,64.19,22.31,64.19,22.31l26.89,12.71,45.86,19.19,90.21,41,78.15-36.18c29.43-8.59,37.8-5.03,42.72,3.72,4.78,8.79,1.73,18.29-22.43,37.49l-74.74,43.01-33.3,148.04-5.91,29.7s-8.28,59.85-20.47,66.28l-30.62,15.98-.86-129.24c-1.82-18.39-5.87-43.01-10.1-55.33-5.64-16.18-7.14-22.91-37.94-6.33l-93.17,37.54-16.24,75.73-24.47,12.76-12.6-63.82-11.1,1.76-7.55-15.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavette);
export default __webpack_public_path__ + "static/media/navette.ea8ef31bde000a535af614f868150c2e.svg";
export { ForwardRef as ReactComponent };